import { registerSteps } from '@/pages/auth/register/types';

interface StepperProps {
  current: number;
}

export default function Stepper({ current }: StepperProps) {
  return (
    <div className="mb-8 flex items-center">
      {registerSteps.map((step, index) => {
        const isDone = current > step.id;
        const isActive = current === step.id;
        return (
          <div key={step.id} className="flex flex-1 items-center last:flex-none">
            <div className="flex flex-col items-center gap-2">
              <span
                className={[
                  'flex h-9 w-9 items-center justify-center rounded-full border text-[13px] font-semibold transition-colors',
                  isDone
                    ? 'border-success-500 bg-success-500 text-white'
                    : isActive
                      ? 'border-primary-500 bg-primary-500 text-white'
                      : 'border-background-300 bg-white text-foreground-400',
                ].join(' ')}
              >
                {isDone ? (
                  <i className="ri-check-line text-base" aria-hidden="true"></i>
                ) : (
                  <i className={`${step.icon} text-base`} aria-hidden="true"></i>
                )}
              </span>
              <span
                className={[
                  'whitespace-nowrap text-[11px] font-medium',
                  isActive || isDone ? 'text-foreground-800' : 'text-foreground-400',
                ].join(' ')}
              >
                {step.title}
              </span>
            </div>
            {index < registerSteps.length - 1 && (
              <span
                className={[
                  'mx-2 mb-5 h-px flex-1',
                  current > step.id ? 'bg-success-500' : 'bg-background-300',
                ].join(' ')}
              ></span>
            )}
          </div>
        );
      })}
    </div>
  );
}